<template>
  <div
    class="flex flex-col h-screen justify-center fixed z-50 inset-0 bg-opacity-90 bg-black"
  >
    <div class="absolute inset-0" @click="close"></div>
    <div class="flex items-center w-full h-full justify-evenly relative">
      <button
        class="button-interactive text-white absolute right-4 top-4"
        @click.prevent="close"
      >
        <close-icon class="w-8 fill-current" />
      </button>

      <div class="w-4/5 h-4/5 z-10" @click="close">
        <img :src="imageUrl" loading="lazy" class="w-full h-full object-contain" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Image Preview",

  props: {
    imageUrl: String,
  },

  methods: {
    close() {
      this.$emit("close");
    },
  },
};
</script>